import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
import 'slick-carousel';
import 'es6-promise/auto';
import _ from 'lodash';



export default class {
  //props: クラスのpropsを拡張する
  constructor(props = {}) {

    //基本のprops
    this.props = {
      visual_box: '.js_slick_box',
      active_css: 'cof_visual__list--is--active'
    };

    //拡張用props
    const ex_props = props || {};

    //propsを拡張。各オブジェクト、シャローコピーでなく、ディープコピーにしてからマージ
    this.props = _.merge({}, _.cloneDeep(this.props), _.cloneDeep(ex_props));

    this.init();

  }
  init() {
    //要素がなければ何もしないで終わり。
    if (!$(this.props.visual_box).length) {
      return;
    }

    //要素の数だけスリック実行
    //箇所ごとに画像のロードをはさみたいので、eachにする
    //プロミスオールでも書けるが、今回は責務切り分けで、ループ。
    $(this.props.visual_box).each((index, el) => {
      this.set_slick(el);
    });
  }

  //画像のロード待ちをするので 非同期関数にする
  async set_slick(el) {


    //imagesLoadededでpromise返す
    await new Promise((resolve) => {
      imagesLoaded(el, () => {
        resolve();
      });
    });
    //画像のロードが終わったらスリック実行。
    $(el).slick(
      {
        dots: true,
        fade: true,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 1000,
      }
    ).addClass(this.props.active_css);//スリック実行時にボックスにクラスつける

  }
}
